<template>
  <div class="expert-think-tank">
    <img :src="bannerObj.image" class="ExpertThinkTank" height="784" />
    <div class="introduce">
      <div class="introduce-img">
        <img src="../../assets/img/introduce.png" alt="" />
        <div class="introduce-mask"></div>
      </div>
      <div class="introduce-desc">
        <div class="tit">
          <em>首页</em
          ><img src="../../assets/img/search-arrow.svg" alt="" /><span
            >专家智库</span
          >
        </div>
        <p>
          美术泛指创作占有一定平面或空间，且具有可视性的艺术。它的划分有多种，一般包括四大门类绘画、雕塑、设计、建筑。现代有些学者也把其它的归纳入这个门类，例如书法、摄影等。“美术”这一名词始见于欧洲17世纪，也有人认为正式出现于18世纪中叶
        </p>
      </div>
    </div>
    <div class="tabs">
      <div class="tabs-content">
        <div class="tabs-column">
          <span
            v-for="(item, index) in tabList"
            :key="item.id"
            :class="{ active: index === activeKey }"
            @click="handleClickActive(index)"
            >{{ item.name }}</span
          >
        </div>
      </div>
    </div>
    <task-show class="to-center" :expertList="expertList"></task-show>
  </div>
</template>

<script>
import TaskShow from "@/components/TaskShow";
import { artBannerList, artExpertTankList } from "@/api/ExpertThinkTank";
export default {
  name: "ExpertThinkTank",
  components: {
    TaskShow,
  },
  data() {
    return {
      tabList: [
        {
          id: 0,
          name: "专家学者",
        },
        {
          id: 1,
          name: "工美大师",
        },
      ],
      activeKey: 0,
      bannerObj: {},
      params: {
        page: 0,
        limit: 10,
        classify: 0,
        keyword: "",
      },
      expertList: [],
    };
  },
  mounted() {
    this.artBannerListFunc();
    this.artExpertTankListFunc();
  },
  methods: {
    artBannerListFunc() {
      artBannerList({
        area: 3,
      })
        .then((res) => {
          this.bannerObj = res.data[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    artExpertTankListFunc() {
      artExpertTankList(this.params)
        .then((res) => {
          console.log("res", res);
          this.expertList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleClickActive(index) {
      if (this.activeKey === index) return;
      if (index === 0) {
        this.params.classify = 0;
        this.artExpertTankListFunc();
      } else {
        this.params.classify = 1;
        this.artExpertTankListFunc();
      }
      this.activeKey = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.expert-think-tank {
  .ExpertThinkTank {
    width: 100%;
  }
  .introduce {
    margin-right: 16px;
    padding-top: 38px;
    height: 478px;
    position: relative;
    overflow: hidden;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: url("../../assets/img/ExpertThinkTank-bg.png") no-repeat right
        50px;
      background-size: 228px 439px;
      opacity: 0.37;
    }
    .introduce-img {
      position: relative;
      float: left;
      margin-right: 18px;
      // width: 960px;
      width: 60%;
      height: 440px;
      img {
        // width: 866px;
        width: 54.9vw;
        min-width: 710px;
        height: 420px;
      }
      .introduce-mask {
        width: 249px;
        height: 70px;
        background-color: rgba(45, 63, 81, 0.69);
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .introduce-desc {
      float: left;
      width: 38%;
      // width: 360px;
      text-align: right;
      font-size: 13px;
      .tit {
        margin-bottom: 114px;
        em {
          display: inline-block;
          padding-left: 16px;
          line-height: 20px;
          background: url("../../assets/img/home.png") no-repeat 0 2px;
          background-size: 14px 14px;
          color: #333;
          cursor: pointer;
        }
        img {
          transform: rotate(-90deg);
          margin: 6px 4px 0;
          vertical-align: top;
        }
        span {
          cursor: pointer;
          color: #aaa;
        }
      }
      p {
        width: auto;
        margin: 0;
        line-height: 20px;
        font-size: 14px;
        color: #7f7f7f;
        text-align: left;
      }
    }
  }
  .tabs {
    height: 142px;
    padding-top: 84px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 50px;
    .tabs-content {
      margin: 0 auto;
      width: 1240px;
      .tabs-column {
        overflow: hidden;
        // float: left;
        // padding-bottom: 50px;
        span {
          float: left;
          width: 70px;
          height: 57px;
          line-height: 33px;
          margin-right: 62px;
          font-size: 17px;
          color: #939ba4;
          cursor: pointer;
          // margin-bottom: -2px;
        }
        .active {
          color: #2d3f51;
          border-bottom: 2px solid #2d3f51;
        }
      }
    }
  }
  .to-center {
    margin: 0 auto;
    width: 1240px;
  }
}
</style>
